import React from 'react';
import S from './styles';
import aboutImage from '../../resources/mainImage.jpg';

export const About = () => (
  <S.Section>
    <S.Wrap>
      <S.ContentsWrap>
        <S.Title
          id='about'
          data-sal="slide-up"
          data-sal-delay="100"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          ABOUT
        </S.Title>
        <S.Contents
          data-sal="slide-up"
          data-sal-delay="300"
          data-sal-duration="600"
          data-sal-easing="ease"
        >
          let us: Go!는 iOS 개발에 관심있는 모두가 모여 개발 노하우와 다양한 경험 그리고 정보를 서로 공유하고 자유롭게 소통하는 iOS 커뮤니티입니다.
          <br /><br />
          새로운 기대로 가득한 봄입니다. 점차 봄이라는 계절과 함께 따뜻한 에너지와 활기가 띠고 있는 것 같아요.
          <br />
          따스한 봄의 기운으로 let us: Go!와 함께 새로운 도전을 하며, 성장하는 기회가 되어보는 건 어떠신가요?! 
          <br /><br />
          `3월 25일 토요일` [let us: Go! 2023 봄]을 개최합니다.
        </S.Contents>
      </S.ContentsWrap>
      <S.Image
        src={aboutImage}
        alt='let us: Go! 2022 fall iOS 단체 사진'
        data-sal="slide-up"
        data-sal-delay="300"
        data-sal-duration="600"
        data-sal-easing="ease"
      />
    </S.Wrap>
  </S.Section>
)
